import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'xilo-mono-form-viewer-grid-new',
  templateUrl: './grid.component.html',
  styleUrls: ['../../assets/custom-theme.scss', './grid.component.scss'],
})
export class CustomGridComponent extends FieldArrayType implements OnInit {
  rows = [];
  headers = [];

  constructor() {
    super();
  }

  ngOnInit() {
    // console.log('Grid: ', this.field);
    this.generateTable();
  }

  generateTable() {
    this.headers = this.field?.fieldGroup[0]?.fieldGroup?.map(
      (f) => {
        return f?.templateOptions?.columnName;
      }
    );
    this.field.fieldGroup.forEach(fg => {
      fg.fieldGroup.forEach(f => {
        if (f.type !== 'text') {
          f.templateOptions.label = null;
        }
      })
    });
    console.log(this.headers);
  }

}
